module.exports = __webpack_public_path__ + "img/bjp-periodo-entrega-2026.90946a50.jpg";